<div class="p-grid">
  <div class="p-col-4" *ngIf="update"></div>
  <div class="p-col-6" *ngIf="!update"></div>
  <div class="p-col-4" *ngIf="update ">
    <p-panel expandIcon="pi pi-fw pi-chevron-down"
             collapseIcon="pi pi-fw pi-chevron-up"
             [collapsed]="true"
             [toggleable]="true"
             *ngFor="let item of oldDataListFiltered"
    >
      <p-header>
        <label class="custom-noblock-label">{{ getHeaderAttribute(item)}}</label>
      </p-header>
      <div class="subheader-section-div" *ngIf="subsectionHeaderArr.length > 0">
        <label class="custom-noblock-label">{{ getSubsectionHeader(item)}}</label>
      </div>
      <div *ngFor="let key of getFilteredObject(item)" style="margin-bottom: 10px">
        <div class="text-heading-att">{{key.translation | translate}}</div>
        {{key.attributeValue}}
        <br/>
      </div>
    </p-panel>
  </div>

  <div class="p-col-4" *ngIf="update">
    <p-panel expandIcon="pi pi-fw pi-chevron-down"
             collapseIcon="pi pi-fw pi-chevron-up"
             [collapsed]="true"
             [toggleable]="true"
             *ngFor="let item of newDataListFiltered"
    >
      <p-header>
        <label class="custom-noblock-label">{{ getHeaderAttribute(item)}}</label>
      </p-header>
      <div class="subheader-section-div" *ngIf="subsectionHeaderArr.length > 0">
        <label class="custom-noblock-label">{{ getSubsectionHeader(item)}}</label>
      </div>
      <div *ngFor="let key of getFilteredObject(item)" style="margin-bottom: 10px">
        <div class="text-heading-att">{{key.translation | translate}}</div>
        {{key.attributeValue}}
        <br/>
      </div>
    </p-panel>
  </div>

  <div class="p-col-6" *ngIf="!update">
    <p-panel expandIcon="pi pi-fw pi-chevron-down"
             collapseIcon="pi pi-fw pi-chevron-up"
             [collapsed]="true"
             [toggleable]="true"
             *ngFor="let item of anyNotFiltered()"
    >
      <p-header>
        <label class="custom-noblock-label">{{ getHeaderAttribute(item)}}</label>
      </p-header>
      <div class="subheader-section-div" *ngIf="subsectionHeaderArr.length > 0">
        <label class="custom-noblock-label">{{ getSubsectionHeader(item)}}</label>
      </div>
      <div *ngFor="let key of getFilteredObject(item)" style="margin-bottom: 10px">
        <div class="text-heading-att">{{key.translation | translate}}</div>
        {{key.attributeValue}}
        <br/>
      </div>
    </p-panel>
  </div>
</div>
